<app-nav-bar></app-nav-bar>

<section class="max-w-[1360px] mx-auto px-5 py-7 lg:py-10">
    <div class="max-w-[1180px] mx-auto">
        <div class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between lg:mb-8">
            <h1
                class="text-[32px] max-[991px]:text-[28px] max-[767px]:text-[24px] max-[576px]:text-[20px] font-medium leading-8 text-black">
                Activity</h1>
        </div>

        <div class="overflow-hidden border-b border-secondary-button-black bg-white">
            <div *ngIf="isLoading" class="px-4 py-16 sm:px-6 lg:px-8 text-center">
                <div class="inline-block">
                    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
                </div>
                <p class="mt-4 text-secondary-text-black">Loading market activity...</p>
            </div>

            <div *ngIf="!isLoading && activities.length === 0" class="px-4 py-8 sm:px-6 lg:px-8 text-center text-secondary-text-black">
                <p>No activity found.</p>
                <p class="text-sm mt-2">Check the browser console for any errors.</p>
            </div>

            <article *ngFor="let item of paginatedActivities"
                class="flex flex-col gap-4 px-4 py-4 md:flex-row md:items-center md:justify-between sm:px-6 lg:px-8 border-b border-secondary-button-black last:border-b-0">
                <div class="flex min-w-0 items-start gap-4">
                    <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-[#FF9500]">
                        <img [src]="item.marketIcon" [alt]="item.marketName" class="h-7 w-7 object-contain" />
                    </div>

                    <div class="min-w-0">
                        <p class="truncate text-base font-medium text-secondary-text-black">
                            {{ item.marketName }} - {{ item.marketWindow }}
                        </p>

                        <!-- 575px and below the address takes a line of its own, with the
                             trade details underneath it -->
                        <div
                            class="mt-1 flex min-w-0 items-center gap-2 text-base text-secondary-text-black max-[576px]:flex-col max-[576px]:items-start max-[576px]:gap-1">
                            <span class="flex min-w-0 max-w-full items-center gap-2 max-[576px]:w-full">
                                <img [src]="item.traderAvatar" [alt]="item.traderName"
                                    class="h-6 w-6 shrink-0 rounded-full object-cover" />
                                <!-- Head truncates to whatever room is left, tail always shows,
                                     so a long address reads as 0xAdf9bE…1105 -->
                                <span class="flex min-w-0 font-semibold text-black">
                                    <span class="truncate">{{ addressHead(item.traderName) }}</span>
                                    <span class="shrink-0">{{ addressTail(item.traderName) }}</span>
                                </span>
                            </span>

                            <span class="shrink-0">
                                bought
                                <span class="font-semibold" [ngClass]="item.actionColor">{{ item.action }}</span>
                                at {{ item.price }} ({{ item.amount }})
                            </span>
                        </div>
                    </div>
                </div>

                <div class="flex shrink-0 items-center gap-2 text-sm font-medium text-secondary-text-black">
                    <span>{{ item.timeAgo }}</span>
                    <a *ngIf="item.txn_hash" [href]="'https://amoy.polygonscan.com/tx/' + item.txn_hash" target="_blank" aria-label="Open activity item"
                        class="inline-flex h-5 w-5 items-center justify-center text-secondary-text-black hover:text-black">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M9.33398 2.6665H13.334V6.6665" stroke="currentColor" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M8.00065 8.00016L13.334 2.66683M6.66732 3.3335H5.60065C4.48055 3.3335 3.92049 3.3335 3.49267 3.55149C3.11635 3.74324 2.81039 4.0492 2.61864 4.42552C2.40065 4.85334 2.40065 5.41339 2.40065 6.5335V10.4002C2.40065 11.5203 2.40065 12.0803 2.61864 12.5081C2.81039 12.8845 3.11635 13.1904 3.49267 13.3822C3.92049 13.6002 4.48055 13.6002 5.60065 13.6002H9.46732C10.5874 13.6002 11.1475 13.6002 11.5753 13.3822C11.9516 13.1904 12.2576 12.8845 12.4493 12.5081C12.6673 12.0803 12.6673 11.5203 12.6673 10.4002V9.3335"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </a>
                </div>
            </article>
        </div>

        <!-- Pagination -->
        <div *ngIf="!isLoading && totalPages > 1"
            class="mt-6 flex min-w-0 items-center justify-center gap-2 max-[991px]:justify-end max-[576px]:gap-1.5">
            <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
                class="shrink-0 px-3 py-2 border border-secondary-button-black rounded-lg text-black disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 max-[576px]:px-2.5">
                <span class="max-[576px]:hidden">←</span> Prev
            </button>

            <!-- Every page number, above 991px -->
            <div class="flex gap-1 max-[991px]:hidden">
                <button *ngFor="let page of pageNumbers"
                    (click)="goToPage(page)"
                    [ngClass]="page === currentPage ? 'bg-black text-white' : 'border border-secondary-button-black text-black hover:bg-gray-50'"
                    class="px-3 py-2 rounded-lg font-medium">
                    {{ page }}
                </button>
            </div>

            <!-- 576px to 991px: current page with its neighbours, then the last
                 two pages, with anything in between collapsed into an ellipsis -->
            <div class="hidden gap-1 max-[991px]:flex max-[576px]:hidden">
                <ng-container *ngFor="let page of compactPageNumbers">
                    <span *ngIf="isPageGap(page)"
                        class="shrink-0 px-1 py-2 font-medium text-secondary-text-black">{{ page }}</span>

                    <button *ngIf="!isPageGap(page)" (click)="goToPage(asPage(page))"
                        [ngClass]="page === currentPage ? 'bg-black text-white' : 'border border-secondary-button-black text-black hover:bg-gray-50'"
                        class="shrink-0 px-3 py-2 rounded-lg font-medium">
                        {{ page }}
                    </button>
                </ng-container>
            </div>

            <!-- 575px and below: first page, an ellipsis, and the last page only -->
            <div class="hidden gap-0.5 max-[576px]:flex">
                <ng-container *ngFor="let page of minimalPageNumbers">
                    <span *ngIf="isPageGap(page)"
                        class="shrink-0 px-1 py-2 font-medium text-secondary-text-black">{{ page }}</span>

                    <button *ngIf="!isPageGap(page)" (click)="goToPage(asPage(page))"
                        [ngClass]="page === currentPage ? 'bg-black text-white' : 'border border-secondary-button-black text-black hover:bg-gray-50'"
                        class="shrink-0 px-2.5 py-2 rounded-lg font-medium">
                        {{ page }}
                    </button>
                </ng-container>
            </div>

            <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
                class="shrink-0 px-3 py-2 border border-secondary-button-black rounded-lg text-black disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 max-[576px]:px-2.5">
                Next <span class="max-[576px]:hidden">→</span>
            </button>
        </div>
    </div>
</section>
